function flattenMessages(
  messages: Record<string, any>,
  prefix = ""
): Record<string, string> {
  let flattened: Record<string, string> = {}

  for (const key in messages) {
    const value = messages[key]
    const newKey = prefix ? `${prefix}.${key}` : key

    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      flattened = { ...flattened, ...flattenMessages(value, newKey) }
    } else {
      flattened[newKey] = String(value)
    }
  }

  return flattened
}

export { flattenMessages }
